<button class="btn-login"
        (click)="showLoginPage()">
    {{getLoginBtnText()}}
</button>
<div class="home">
    <div class="games-menu__body">

        <div class="games-menu__body-inner"
             [class.is-active]="isNoActiveTab()">
            <div class="games-menu__popup">
                <div class="games-popup">
                    <div class="games-popup__text">
                        <ng-container *ngIf="!isSenetProvider()">
                            The default login credentials are below.
                        </ng-container>
                        <ng-container *ngIf="isSenetProvider()">
                            Click PLAY btn to start game
                        </ng-container>
                        <span *ngIf="showChangingPasswordText()">
                            If you change the default password, the initial password will no longer work.
                        </span>
                    </div>

                    <ng-container *ngIf="isGameWithAccountAndPassword()">
                        <div class="games-popup__row">
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title">Password</span>
                            </div>
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title c-accent"
                                      [class.is-blurred]="!isUserLogged()">
                                    {{getGamePassword()}}
                                </span>
                            </div>
                        </div>
                        <div class="games-popup__row">
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title">Account</span>
                            </div>
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title c-accent"
                                      [class.is-blurred]="!isUserLogged()">
                                    {{getGameAccount()}}
                                </span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isGDProvider()">
                        <div class="games-popup__row">
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title">Mobile ID</span>
                            </div>
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title c-accent"
                                      [class.is-blurred]="!isUserLogged()">
                                    {{getGameMobileId()}}
                                </span>
                            </div>
                        </div>
                        <div class="games-popup__row">
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title">Password</span>
                            </div>
                            <div class="games-popup__col games-popup__col--half">
                                <span class="games-popup__title c-accent"
                                    [class.is-blurred]="!isUserLogged()">
                                    {{getGameGDPassword()}}
                                </span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="getGamePin() && isRiverProvider()">
                        <div class="games-popup__row" style="justify-content: center">
                            <div class="games-popup__col">
                                <span class="games-popup__title"
                                      [class.is-blurred]="!isUserLogged()">
                                    {{getGamePin()}}
                                </span>
                            </div>
                        </div>
                    </ng-container>


                    <div class="games-popup__row games-popup__row--btns games-popup__row--mg-small"
                         style="margin-top: 1em">
                        <button class="games-btn"
                                *ngIf="!isSenetProvider()"
                                id="copyBtn"
                                [disabled]="!isUserLogged()"
                                (click)="copyToBuffer(true)">
                            <span>{{copyButtonText}}</span>
                        </button>
                        <button class="games-btn"
                                [disabled]="!isUserLogged()"
                                (click)="onGameSweep()">
                            <span>Play</span>
                        </button>
                        <button class="games-btn"
                                [disabled]="!isUserLogged()"
                                (click)="goToSupport()">
                            <span>Support</span>
                        </button>
                    </div>
                    <div class="games-info">
                            <span>
                                To copy your account ID, click the copy Button.
                            </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="games-menu__body-inner"
             [class.is-active]="isRedeemTabActive()">
            <div class="games-menu__popup">
                <div class="games-popup">
                    <button class="games-popup__close-btn close-btn"
                            (click)="onCloseTabs()">
                        <img src="../../../assets/images/games-playground/close-btn.png"
                             title="Close"
                             alt="Close">
                    </button>
                    <div class="games-popup__text">
                        This is what you can redeem on <span class="c-accent">{{getGameName() | titlecase}}</span>. <br>
                        Enter the Amount, and click Redeem.
                    </div>
                    <div class="games-popup__row" style="align-items: center">
                        <div class="games-popup__col games-popup__col--half">
                            <span class="games-popup__title">
                                {{getGameName() | titlecase}} WINS
                            </span>
                        </div>
                        <div class="games-popup__col games-popup__col--half">
                            <span class="games-popup__title c-accent"
                                  *ngIf="!getGameBalanceLoaderState()"
                                  [class.is-blurred]="!isUserLogged()">
                                {{formatCurrency(getGameBalance())}}
                            </span>
                            <span class="games-popup__title c-accent"
                                  *ngIf="isUserLogged() && getGameBalanceLoaderState()">
                                <div class="balance-loader"></div>
                            </span>

                        </div>
                    </div>

                    <form  [formGroup]="redeemForm">
                        <div class="games-popup__row games-popup__row--center" style="margin-top: 1em">
                            <div class="games-popup__input-wrapper">
                                <input #redeemAmount
                                       formControlName="amount"
                                       mask="separator.0"
                                       thousandSeparator=","
                                       placeholder="AMOUNT"
                                       (input)="onRedeemAmountInput()"
                                       [attr.disabled]="!isUserLogged() || getGameBalanceLoaderState() ? '' : null"
                                       type="tel"
                                       class="games-popup__input">
                                <div class="games-popup__input-available" [class.is-active]="moreThenAvailableRedeemPayout">
                                    Available {{formatCurrency(getGameBalance())}}
                                </div>
                            </div>
<!--                            <button class="games-btn"-->
<!--                                    (click)="onSubmitRedeem()"-->
<!--                                    [disabled]="!+redeemAmount.value || !isUserLogged()">-->
<!--                                <span>redeem</span>-->
<!--                            </button>-->
                            <app-button-loading
                                #redeemBtn
                                (onClick)="onSubmitRedeem(redeemBtn)"
                                [disabledInner]="!+redeemAmount.value || !isUserLogged() || getGameBalanceLoaderState()">
                                redeem
                            </app-button-loading>
                        </div>
                    </form>
                    <div class="games-info">
                            <span>
                                All redeems are final.
                            </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="games-menu__body-inner"
             [class.is-active]="isDepositTabActive()">
            <div class="games-menu__popup">
                <div class="games-popup">
                    <button class="games-popup__close-btn close-btn"
                            (click)="onCloseTabs()">
                        <img src="../../../assets/images/games-playground/close-btn.png"
                             title="Close"
                             alt="Close">
                    </button>
                    <div class="games-popup__text" style="min-height: 3em">
                        <ng-container *ngIf="isUserLogged()">
                            You have {{getEntriesBalance()}} available in Sweepstakes Entries, and ${{getWinningsBalance()}} in Winnings
                        </ng-container>
                        <ng-container *ngIf="!isUserLogged()">
                            You can deposit from either Sweeps Entries or from your Winnings
                        </ng-container>
                    </div>

                    <form  [formGroup]="depositForm">
                        <div class="games-popup__row games-popup__row--center">
                            <div class="games-popup__input-radio">
                                <input type="radio"
                                       name="paymentType"
                                       checked
                                       (change)="onDepositPaymentTypeChanged()"
                                       id="entries">
                                <label for="entries">
                                     <span style="display:flex;flex-direction: column">
                                         <span class="games-popup__title c-accent"
                                               [class.is-blurred]="!isUserLogged()">
                                             {{getEntriesBalance()}}
                                         </span>
                                         <span class="games-popup__title">Entries</span>
                                     </span>
                                </label>
                            </div>
                            <div class="games-popup__input-radio">
                                <input type="radio"
                                       name="paymentType"
                                       (change)="onDepositPaymentTypeChanged()"
                                       id="spend">
                                <label for="spend">
                                    <span style="display:flex;flex-direction: column">
                                        <span class="games-popup__title c-accent"
                                              [class.is-blurred]="!isUserLogged()">
                                            ${{getWinningsBalance()}}
                                        </span>
                                        <span class="games-popup__title">WINNINGS</span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="games-popup__row games-popup__row--center" style="margin-top: 1em">
                            <div class="games-popup__input-wrapper">
                                <input #depositAmount
                                       formControlName="amount"
                                       mask="separator.0"
                                       thousandSeparator=","
                                       placeholder="AMOUNT"
                                       (input)="onDepositAmountInput()"
                                       type="tel"
                                       [attr.disabled]="!isUserLogged() ? '' : null"
                                       class="games-popup__input">
                                <div class="games-popup__input-available" [class.is-active]="moreThenAvailablePayout">
                                    Available
                                    <ng-container *ngIf="!this.isPaymentTypeEntries()">${{getDepositPaymentType()}}</ng-container>
                                    <ng-container *ngIf="this.isPaymentTypeEntries()">{{getDepositPaymentType()}}</ng-container>
                                </div>
                            </div>
<!--                            <button class="games-btn"-->
<!--                                    (click)="onSubmitDepositForm()"-->
<!--                                    [disabled]="!+depositAmount.value || !isUserLogged()">-->
<!--                                <span>Deposit</span>-->
<!--                            </button>-->

                            <app-button-loading
                                    #depositBtn
                                    (onClick)="onSubmitDepositForm(depositBtn)"
                                    [disabledInner]="!+depositAmount.value || !isUserLogged()">
                                Deposit
                            </app-button-loading>
                        </div>
                        <div class="games-info">
                            <span>
                                All deposits are final.
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="games-menu__body-inner"
             [class.is-active]="isLoginTabActive()">
            <app-login *ngIf="isLoginTabActive()"></app-login>
        </div>
    </div>
</div>
<app-games-list></app-games-list>

